import { render } from "./ClipboardToPDF.vue?vue&type=template&id=9fb63c20&scoped=true"
import script from "./ClipboardToPDF.vue?vue&type=script&lang=js"
export * from "./ClipboardToPDF.vue?vue&type=script&lang=js"

import "./ClipboardToPDF.vue?vue&type=style&index=0&id=9fb63c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb63c20"]])

export default __exports__